<div class="phase_cohorts_details_container">
    <div *ngFor="let cohort of cohorts" class="lx-body phase_cohorts_details_container__cohorts">
        {{cohort}}
    </div>
    <div *ngIf="devices" class="phase_cohorts_details_container__devices">
        <span class="lx-header">Devices</span>
        <span class="lx-body">{{devices}}</span>
    </div>
    <div *ngIf="online" class="phase_cohorts_details_container__online">
        <span class="lx-header">Online</span>
        <span class="lx-body">{{online}}</span>
    </div>
</div>